import { render, staticRenderFns } from "./Cohorts.vue?vue&type=template&id=73e92cba&scoped=true"
import script from "./Cohorts.vue?vue&type=script&lang=js"
export * from "./Cohorts.vue?vue&type=script&lang=js"
import style0 from "./Cohorts.vue?vue&type=style&index=0&id=73e92cba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e92cba",
  null
  
)

export default component.exports